import { Link as LinkIcon, LinkOff } from "@mui/icons-material";
import { Divider, IconButton, Tooltip } from "@mui/material";
import cx from "classnames";

interface DateRangeCalendarDividerProps {
  isLinked: boolean;
  onLinkClick: () => void;
  withDivider?: boolean;
}

const DateRangeCalendarDivider = ({
  isLinked,
  onLinkClick,
  withDivider = true,
}: DateRangeCalendarDividerProps) => {
  const Icon = isLinked ? LinkIcon : LinkOff;

  return (
    <div className={cx("flex justify-center flexItem relative w-6")}>
      <Tooltip
        arrow
        enterDelay={500}
        title={
          <>
            Toggle linked calendars so when one side's month or year changes, the
            other side updates to the same month or year.
            <br />
            <br />
            Applies only when no day selection has been made.
          </>
        }
      >
        <IconButton
          size="small"
          className={cx("absolute! size-6 inset-0 m-auto!", {
            "bg-neutral-light": !withDivider,
          })}
          onClick={onLinkClick}
        >
          <Icon fontSize="small" color="action" />
        </IconButton>
      </Tooltip>
      {withDivider && <Divider orientation="vertical" flexItem />}
    </div>
  );
};

export default DateRangeCalendarDivider;
